var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgExercise = function SvgExercise(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 18,
    fill: "none",
    viewBox: "0 0 16 18"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10.59,
    cy: 2.48,
    r: 1.48,
    stroke: "currentColor",
    strokeWidth: 2,
    vectorEffect: "non-scaling-stroke"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M2 14.78s3.2-.38 4.3-1.93l1.4-3.1m6.9-5.5s-.94 2.89-2.38 2.82C11.34 7.04 11.17 6 10.3 5.9c-.88-.1-2.6 3.85-2.6 3.85m0 0s2.64.63 3.34 2.22c.7 1.6.44 5.04.44 5.04M7.93 5.6s-2.31.11-2.67.29c-.89.43-1.63 1.92-1.63 1.92",
    vectorEffect: "non-scaling-stroke"
  })));
};
export default SvgExercise;